<template>
  <div>
    <span class="created-label"
      >{{ t == 1 ? this.$t("Təyin_olunmayıb:") : this.$t("Yadda_saxlanıb")  }} : {{ c }}</span
    >
  </div>
</template>

<script>
export default {
  props: {
    created: String,
    type: Number,
  },
  data() {
    return {
      c: this.created,
      t: this.type,
    };
  },
  watch: {
    created() {
      this.c = this.created;
    },
    type() {
      this.t = this.type;
    },
  },
};
</script>

<style>
.created-label {
  font-size: var(--font-primary);
  font-style: italic;
}
</style>